module.exports = __webpack_public_path__ + "static/media/tipologia16.28de43de.png";